import type {ReactElement, RefObject} from 'react';
import {useState} from 'react';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import styles from '@Components/social-media/components/preview-video-player/preview-video-player.module.scss';

interface PreviewVideoPlayerProps {
  videoRef: RefObject<HTMLVideoElement | null>;
}

export function PreviewVideoPlayer({videoRef}: PreviewVideoPlayerProps): ReactElement {
  const [isPlaying, setIsPlaying] = useState(false);

  const onPlayPause = (): void => {
    if (!videoRef.current) {
      return;
    }

    if (isPlaying) {
      videoRef.current.pause();
      setIsPlaying(false);
      return;
    }

    void videoRef.current.play();
    setIsPlaying(true);
  };

  const getPlayPauseLabel = (): string => {
    return isPlaying ? window.i18next.t('pmwjs_pause_2') : window.i18next.t('pmwjs_play_video');
  };

  const getPlayPauseIcon = (): string => {
    return isPlaying ? 'icon-pause' : 'icon-play-video';
  };

  return (
    <div className={styles.playPauseBadgeHolder}>
      <Icon
        ariaLabel={getPlayPauseLabel()}
        icon={getPlayPauseIcon()}
        isUsedAsButton
        onClick={onPlayPause}
        shape={IconShape.CIRCLE}
        size={IconSize.SIZE_ICON_16}
        type={IconType.SECONDARY}
      />
    </div>
  );
}
